/* ========================================================================= */
/* Location */
/* ========================================================================= */

/** @type {import("$types/generated/cms-graphql").GlobalQueryQuery} */
let GLOBAL_QUERY;

/**
 * Set global variable GLOBAL_QUERY
 * @param {typeof GLOBAL_QUERY} d Global query data
 */
export const setGlobalQuery = (d) => {
    GLOBAL_QUERY = d;
};

/**
 * Get global variable GLOBAL_QUERY
 */
export const getGlobalQuery = () => {
    // new URL or something
    return GLOBAL_QUERY;
};
